import React from "react";
import CSSModules from "react-css-modules";
import styles from "./glanceBox.scss";
import PropTypes from "prop-types";
import _get from 'utils/get';

@CSSModules(styles)
class GlanceBox extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    dataAt: PropTypes.string,
    children: PropTypes.node,
    color: PropTypes.oneOf(["black", "green", "red", "yellow"]),
    styles: PropTypes.object
  };

  render() {
    const { title, dataAt, color = "black" } = this.props;
    const glanceBockOverrideClassName = _get(this, ['props', 'styles', 'glanceBox'], "");
    return (
      <div className={`${styles.glanceBox} ${styles[color]} ${glanceBockOverrideClassName}`}>
        <div
          className={`${styles.label} ${styles[color]}`}
          data-at={`${dataAt}-box-label`}
        >
          {title}
        </div>
        <div>{this.props.children}</div>
      </div>
    );
  }
}

export default GlanceBox;



// WEBPACK FOOTER //
// ./src/components/common/glanceBox/GlanceBox.js